query GlobalSearchHints($searchRequest: SearchRequestInput!) {
  globalSearchHints(searchRequest: $searchRequest) {
    nodes {
      id
      caption
      linkType
      resultsCount
    }
  }
}
